import React from 'react';
import './App.css';
import Dashboard from './dashboard.js'
import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import AutoglyphDetails from './AutoglyphDetails.js';
import PlotGraph from './PlotGraph.js';
import Footer from './components/Footer.js';

function RouteScrollManager() {
  const { pathname } = useLocation();
  const prevPathRef = React.useRef(pathname);

  React.useLayoutEffect(() => {
    const prev = prevPathRef.current;
    const curr = pathname;
    if (prev === curr) return;

    if (prev === '/' && curr !== '/') {
      document.body.dataset.scrollY = String(window.scrollY);
      window.scrollTo(0, 0);
    } else if (prev !== '/' && curr === '/') {
      const y = parseInt(document.body.dataset.scrollY || '0', 10);
      window.scrollTo(0, y);
    } else {
      window.scrollTo(0, 0);
    }
    prevPathRef.current = curr;
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
    	<BrowserRouter>
          <RouteScrollManager />
          <Route path="/" children={({ match }) => (
            <div style={{ display: match && match.isExact ? '' : 'none' }}>
              <Dashboard />
            </div>
          )} />
          <Switch>
            <Route
              exact
              path="/autoglyph-details/:id"
              component={AutoglyphDetails}
            />
            <Route
              exact
              path="/graph"
              component={PlotGraph}
            />
          </Switch>
        </BrowserRouter>
        <Footer />
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js